import axios from '@axios'

export const state = {
  smss: [],
}

export const getters = {
  allSms: (state) => state.smss,
}

export const mutations = {
  GET_SMS: (state, resp) => {
    if (!resp) return null
    state.smss = resp.smss || []
  },
  UPDATE_SMS: (state, resp) => {
    if (!resp) return null
    state.smss = resp.smss
  },
  CREATE_SMS: (state, resp) => {
    if (!resp) return null
    state.smss.unshift(resp)
  },
  DELETE_SMS: (state, smss) => {
    state.smss = state.smss.filter((w) => w.id !== smss.id)
  },
}

export const actions = {
  async getSms({ commit }, params) {
    await axios
      .get(`/api/sms`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_SMS', resp.data)
        }
      })
      .catch((err) => {
        commit('GET_SMS', err.response.status === 404 ? { smss: [] } : null)
      })
  },
  async createSms({ commit, dispatch }, payload) {
    return axios.post(`/api/sms/${payload.carId}`, payload)
  },
  async deteleSms({ commit, dispatch }, smss) {
    await axios
      .delete(`/api/sms/${smss.id}`, {
        data: smss,
      })
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_SMS', smss)
          let notification = {
            id: Date.now(),
            type: 'success',
            title: 'DELETE',
            message: 'The state has been deleted',
          }
          dispatch('notification/addNotification', notification, { root: true })
        }
      })
  },
  async updateSms({ commit }, smss) {
    return axios.put(`/api/sms/${smss.id}`, smss)
  },
  async getSmsByCarId({ commit }, { carId }) {
    return axios
      .get(`/api/sms/${carId}`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_SMS', resp.data)
        }
      })
      .catch(() => {
        commit('GET_SMS', { smss: [] })
      })
  },
}
